import LoginBaseLayout from '@components/LoginBaseLayout';
import SignInForm from '@source/components/SignInForm';

const SignIn: React.FC = (): JSX.Element => {
  return (
    <LoginBaseLayout title="Login">
      <SignInForm />
    </LoginBaseLayout>
  );
};

export default SignIn;
